import { Component, Inject, OnInit } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ActionConfirmModal } from './action-confirm-modal';
import { ModalRole } from './modal-role.enum';

@Component({
  selector: 'app-action-confirm-modal',
  templateUrl: './action-confirm-modal.component.html',
  styleUrls: ['./action-confirm-modal.component.scss']
})
export class ActionConfirmModalComponent implements OnInit {
  icon: string = '';
  themeColor: ThemePalette;
  constructor(
    private matDialogRef: MatDialogRef<ActionConfirmModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ActionConfirmModal
  ) {

  }




  ngOnInit(): void {
    this.setIcon();
  }

  confirm(): void {
    this.matDialogRef.close(true);
  }

  private setIcon() {
    if (this.data.role === ModalRole.MODAL_DANGER) {
      this.icon = 'warning';
      this.themeColor = 'warn';
    } else if (this.data.role === ModalRole.MODAL_INFO) {
      this.icon = 'info';
      this.themeColor = 'primary';
    } else {
      this.icon = 'warning';
      this.themeColor = 'primary';
    }
  }
}
